export const NAME = 'config';

export const defaultConfig = {};
